import { BackendClient, type BackendTypes } from '@tf/api';

export const monitoringSearchesQuery = async (
	params: BackendTypes.MonitoringSearchesParams
): Promise<BackendTypes.MonitoringSearchesData> => {
	const res = await BackendClient.getInstance().monitoringSearches(params);

	return res.json();
};
